import { render, staticRenderFns } from "./ATenantDelete.vue?vue&type=template&id=648776a9&"
import script from "./ATenantDelete.vue?vue&type=script&lang=js&"
export * from "./ATenantDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports